import { cn } from '@/lib/utils';

export interface ScienceProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  width?: number;
  height?: number;
  fill?: string;
}

export function Science({
  size = 20,
  width,
  height,
  fill = '#1F3959',
  className,
  ...props
}: ScienceProps) {
  const w = width ?? size;
  const h = height ?? size;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 14.9987 13.3333"
      fill="none"
      className={cn('inline-block flex-shrink-0', className)}
      aria-hidden="true"
      {...props}
    >
      <path
        d="M8.33267 6.10833L12.4993 11.6667H2.49933L6.666 6.10833V1.66667H8.33267M10.7993 0H4.19933C3.84933 0 3.65767 0.4 3.87433 0.675L4.99933 2.08333V5.55833L0.165999 12C-0.242334 12.55 0.149332 13.3333 0.832666 13.3333H14.166C14.8493 13.3333 15.241 12.55 14.8327 12L9.99933 5.55833V2.08333L11.1243 0.675C11.341 0.4 11.1493 0 10.7993 0Z"
        fill={fill}
      />
    </svg>
  );
}
